import React, { ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalStorage } from '@shared/utils';
import { Languages } from '@app/i18n';
import { LanguageButton } from './LanguageButton';

import styles from './styles.module.scss';
import headerStyles from '../header/styles.module.scss';
import { useDidMount } from '@/shared/hooks/useDidMount';
import { Languages as TLanguages } from '@/shared/types';

import LanguageIcon from './assets/language.svg?react';

type Props = {
    setTooltipContent: (p: ReactNode) => void;
};

export const Language: React.FC<Props> = ({ setTooltipContent }) => {
    const [, i18n] = useTranslation();
    const [lang, setLang] = useLocalStorage('lang', '');

    useDidMount(() => {
        if (!lang) setLang(i18n.language);
    });

    const changeLanguage = useCallback(
        (lng: string) => {
            i18n.changeLanguage(lng);
            setLang(lng);
        },
        [i18n, setLang]
    );

    const handleMouseEnter = useCallback(
        () =>
            setTooltipContent(
                <div className={headerStyles.tooltipContent}>
                    {Object.keys(Languages).map((lng) => (
                        <LanguageButton
                            language={lng as TLanguages}
                            current={i18n.language}
                            change={changeLanguage}
                            key={lng}
                        />
                    ))}
                </div>
            ),
        [setTooltipContent, i18n, changeLanguage]
    );

    return (
        <div className={styles.dropdown} onMouseEnter={handleMouseEnter} data-testid="language-selector-trigger">
            <a
                className={styles.selected}
                data-tooltip-id="header-end-tooltip"
                data-tooltip-place="bottom"
                data-tooltip-class-name={styles.tooltip}
            >
                <LanguageIcon />
            </a>
        </div>
    );
};
